// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"TranslationReadyGuard_loaderContainer__bZeYO"};